import { sum } from 'lodash';
import { ListResult } from '../services/dtos/listResult';

export const getNextPageParam = <T, R extends ListResult<T>>(lastPage: R, pages: R[]): number | undefined => {
  const { totalResults } = lastPage;
  const currentlyLoadedCount = sum(pages.flatMap((c) => c.results.length));
  return currentlyLoadedCount < totalResults ? pages.length : undefined;
};
